import http from "./http";

export const fetchTransactionData = () => http.get("/users/transactions");
export const executeWithdrawFunds = (credentials) => http.post("/users/transactions/wallet/withdraw", credentials)
export const getWalletTransaction = () => http.get("/users/transactions/wallet")